import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import employees from 'modules/employees/store/collections/employees'
import { employeeManagedEmployees } from 'modules/employees/store/collections/employeesContractVersions'
import type Employee from 'modules/employees/store/models/Employee'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { peopleLedByEmployee } from 'modules/teams/store/peopleLedByEmployee'

import { usePermissions } from './usePermissions'

export function useSelectableEmployeesByCurrent(contractVersions: ContractVersions): Employee[] {
  const { employee } = useCurrentSession()
  const currentEmployeeId = employee?.id

  const [
    {
      canCreateShiftsForEverybody,
      canCreateShiftsForTeam,
      canCreateShiftsForReportees,
      canCreateShiftsForSelf,
    },
  ] = usePermissions()

  if (canCreateShiftsForEverybody) return employees.active

  const currentEmployee = employees.find({ id: currentEmployeeId })
  let list = currentEmployee && canCreateShiftsForSelf ? [currentEmployee] : []

  if (!currentEmployee) return list

  if (canCreateShiftsForReportees) {
    list = list.concat(employeeManagedEmployees(currentEmployee, contractVersions))
  }

  if (canCreateShiftsForTeam) {
    list = list.concat(
      peopleLedByEmployee(teams, memberships, currentEmployee.id, contractVersions)
    )
  }

  return [...new Set(list)]
}
